// Zuum Theme — zuum.js

// Nav scroll effect
(function() {
  var nav = document.querySelector('.site-nav');
  if (!nav) return;
  window.addEventListener('scroll', function() {
    if (window.scrollY > 60) {
      nav.style.background = 'rgba(0,0,0,0.95)';
    } else {
      nav.style.background = 'rgba(0,0,0,0.9)';
    }
  }, { passive: true });
})();
